module.exports = __webpack_public_path__ + "img/word.592738b8.svg";